import { DropdownMenu, Menu } from "semantic-ui-react";

import { Dropdown } from "components";
import { Link } from "components/ReactScroll/index";
import { useOverflowTabs } from "components/Tabs/hooks";
import "components/Tabs/Tabs.scss";

export type TabData = {
  id: string;
  data?: any;
  title?: string;
  icon?: React.ReactNode;
};

type TabsProps = {
  data: Map<string, TabData>;
  offset?: number;
  hideBorder?: boolean;
};

export const Tabs = ({ data, offset = -100, hideBorder }: TabsProps) => {
  const { canSpy, setActiveTab, activeTab, handleTabClick, tabsContainerRef, visibleTabs, overflowTabs } = useOverflowTabs(data);

  const renderTab = ([_key, item]: [string, TabData]) => {
    if (!item.data) return null;

    const getTabDataCount = (tabData: Record<string, string[] | number[]>) => {
      if (Array.isArray(tabData)) return tabData.length;
      if (typeof tabData === "object") return Object.values(tabData).reduce((acc, curr) => (Array.isArray(curr) ? acc + curr.length : acc), 0);

      return 0;
    };

    const count = getTabDataCount(item.data);
    const fullTitle = item.title ? `${item.title} ${count > 0 ? `(${count})` : ""}` : "";

    return (
      <Link key={item.id} to={item.id} spy={canSpy} smooth={true} offset={offset} duration={300} onSetActive={() => setActiveTab(item.id)} containerId="containerId">
        <Menu.Item as="span" active={item.id === activeTab} onClick={() => handleTabClick(item.id)} title={fullTitle}>
          {item.icon}
          {item.title ? fullTitle : count > 0 && <span>({count})</span>}
        </Menu.Item>
      </Link>
    );
  };

  return (
    <div ref={tabsContainerRef} className={`tabs-container ${hideBorder ? "hideBorder" : ""}`} style={{ position: "relative" }}>
      <Menu pointing secondary color="green">
        {visibleTabs.map(renderTab)}

        {overflowTabs.length > 0 && (
          <Dropdown item icon="ellipsis horizontal" className="overflow-dropdown" pointing="top right" style={{ marginLeft: "auto" }}>
            <DropdownMenu>
              {overflowTabs.map(([_key, item]) => (
                <Link
                  key={item.id}
                  to={item.id}
                  spy={canSpy}
                  smooth={true}
                  offset={offset}
                  duration={300}
                  onSetActive={() => setActiveTab(item.id)}
                  containerId="containerId"
                >
                  <Menu.Item as="span" className="dropdown-menu-item" active={item.id === activeTab} onClick={() => handleTabClick(item.id)}>
                    {item.icon}
                    {item.title}
                  </Menu.Item>
                </Link>
              ))}
            </DropdownMenu>
          </Dropdown>
        )}
      </Menu>
    </div>
  );
};

export default Tabs;
